import { statuses } from '../dataTypes/orderRequests/statuses'

export const status2TranslationMap: Map<string, string> = new Map([
  [statuses.All, 'order_requests_status_all'],
  [statuses.WaitingForIssuance, 'order_requests_status_waiting_for_issuance'], //     Ожидает выдачи
  [statuses.WaitingForSpend, 'order_requests_status_waiting_for_spend'], //           Ожидает проведения
  [statuses.Spent, 'order_requests_status_spent'], //                                 Проведена
  [statuses.OpenedRequest, 'order_requests_status_opened_request'], //                Открытая заявка
  [statuses.WaitingForProcessing, 'order_requests_status_waiting_for_processing'], // Ожидает обработки
  [statuses.Removed, 'order_requests_status_removed'], //                             Удалена
])

export const status2ColorMap: Map<string, string> = new Map([
  [statuses.WaitingForIssuance, 'orangered'],
  [statuses.WaitingForSpend, 'orange'],
  [statuses.Spent, 'limegreen'],
  [statuses.OpenedRequest, 'dodgerblue'],
  [statuses.WaitingForProcessing, 'magenta'],
  [statuses.Removed, 'slategray'],
])

export const undefinedStatusColor = 'silver'
export const undefinedStatusTranslation = 'order_requests_status_undefined'
